import { UserPlus } from "lucide-react";
import ShareMenu from "./ShareMenu";

const ORIGIN = typeof window !== "undefined" ? window.location.origin : "";
const INVITE_TEXT = `Unisciti a Libri in Circolo, la comunità che fa girare i libri: dona o scambia gratuitamente i libri che non leggi più con altri cittadini della tua zona! ${ORIGIN}`;

export default function InviteFriend({ variant = "outline", size = "sm", align = "end", className, label = "Invita un amico" }) {
  return (
    <ShareMenu
      url={ORIGIN}
      text={INVITE_TEXT}
      emailSubject="Ti invito su Libri in Circolo"
      label={<><UserPlus className="w-4 h-4 mr-2" />{label}</>}
      variant={variant}
      size={size}
      align={align}
      className={className}
      icon={false}
      testid="invite"
    />
  );
}
